import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import CustomDialog from 'components/CustomDialog';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { requestPasswordReset } from 'store/slices/user';
import Grid from '@mui/material/Unstable_Grid2';
import { Button, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { isValidEmail } from 'utils/Validation';

const ForgotPassword: React.FC = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const user = useAppSelector((state) => state.user);
    const { requestingPasswordReset, requestPasswordResetSuccess, requestPasswordResetError } = user;

    const [email, setEmail] = useState('');
    const [formError, setFormError] = useState('');

    const handleSubmit = () => {
        if (!isValidEmail(email)) {
            setFormError('Please enter a valid email address.');
            return;
        }
        void dispatch(requestPasswordReset(email));
    };

    return (
        <CustomDialog
            processing={requestingPasswordReset}
            processingCopy="Sending reset link..."
            error={requestPasswordResetError}
            errorContent={<Typography>Something went wrong. Please try again.</Typography>}
            success={requestPasswordResetSuccess}
            successContent={
                <>
                    <Typography variant="subtitle1">Check your email</Typography>
                    <Typography variant="body1">
                        If that address is registered, you&apos;ll receive a password reset link shortly.
                    </Typography>
                </>
            }
            title="Forgot password"
            onClose={() => history.push('/sign-in')}
        >
            {!requestingPasswordReset && !requestPasswordResetSuccess && !requestPasswordResetError ? (
                <form>
                    <Grid container spacing={1}>
                        <Grid xs={12}>
                            <TextField
                                fullWidth
                                label="Email"
                                type="email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setFormError('');
                                }}
                                placeholder="Enter your email"
                                error={!!formError}
                            />
                        </Grid>
                        {formError && (
                            <Grid xs={12}>
                                <Box color="error.main" textAlign="center" mt={1}>
                                    {formError}
                                </Box>
                            </Grid>
                        )}
                        <Grid xs={12}>
                            <Box sx={{ width: '100%', textAlign: 'center', pt: 2 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={requestingPasswordReset}
                                >
                                    Send reset link
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            ) : null}
        </CustomDialog>
    );
};

export default ForgotPassword;
